import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import { convertDateToUTC , convertDateToUTCEpoch } from "../../../Helper/date";
import { TranslateContext } from "../TranslateContext";
import CopyRepElement from "../../../GB_App/formSections/itemsTab/copyRepElement";
import { useCurrentShipmentType } from "../../../hooks";

const SupportingDocumentDetails =({item:{code,ref,expiration,line,authority,part,qty,id},deleteData,updateData,saveData,isItemsTab,copyData})=>{
  const { isDisabled }=useCurrentShipmentType()
  const supportingDocList = useSelector((state) => state.DropDownValues.supportingDocuments)
  const translate = React.useContext(TranslateContext).translate
 
  const isFormDisabled =false;
  return (
  
      <Grid.Row>
        {isItemsTab &&(
          <Grid.Column width={1} style={{textAlign:'center'}}>
            <CopyRepElement 
                 title='SUPPORTING_DOCS'
                 request={{ code,ref,expiration,line,authority,part,qty }}
                 callback={copyData}
                 isFormDisabled={isDisabled}
            />
          </Grid.Column>
        )}
        <Grid.Column
          width={isItemsTab ? 2 : 3}
          className="divFormFeild border-bottom  b-rw-0"
        >
          <DropDown
            clearable
            id={`docCode-${id}`}
            disabled={isFormDisabled}
            className="field-bg dropdown100 addInfoCode"
            labelClass="text-none"
            label={translate("DOC_CODE")}
            boxNumber="44"
            isLabel={true}
            data={supportingDocList}
            value={code}
            onChange={(value) =>{
              saveData({id, code:value})
              updateData(id,{code:value})}
            }
            
          />
        </Grid.Column>

        <Grid.Column width="2" className="divFormFeild  border-bottom  b-rw-0">
          <InputField
            isLabel={false}
            id={`reference-${id}`}
            type="text"
            label={translate("REF")}
            value={ref}
            className={"field-bg"}
            clearInput={false}
            onChange={(value) =>updateData(id,{"ref":value})}
            onBlur={(value) =>saveData({id,ref:ref || " "})}
          />
        </Grid.Column>
        <Grid.Column width="2" className="divFormFeild border-bottom b-rw-0">
        <InputField  
                id={`expiration-${id}`}
                name="expiration"
                type="date"
                label={translate("EXPIRATION", {ns:["default", "header"]})}
                className="field-bg"
                isLabel={false}
                clearInput={false}
                value={ convertDateToUTC(expiration)} 
          
                onChange={(value) => {
                  value=convertDateToUTCEpoch(value)
                  updateData(id,{"expiration":value})
                  saveData({id,expiration})
                  }}
              />
          
        </Grid.Column>
        <Grid.Column width="2" className="divFormFeild  border-bottom b-rw-0  ">
          <InputField
            isLabel={false}
            id={`line-${id}`}
            type="text"
            value={line}
            label={translate("LINE", {ns:["default", "header"]})}
            className={"field-bg"}
            clearInput={false}
          //  disabled={isFormDisabled}
            onChange={(value) => updateData(id, {"line":value})}
            onBlur={(value) => saveData({id, line:line || " "})}
          />
        </Grid.Column>
        <Grid.Column width="2" className="divFormFeild  border-bottom b-rw-0  ">
          <InputField
            isLabel={false}
            id={`authority-${id}`}
            type="text"
            value={authority}
            label={translate("AUTHORITY", {ns:["default", "header"]})}
            className={"field-bg"}
            clearInput={false}
          //  disabled={isFormDisabled}
            onChange={(value) => updateData(id, {"authority":value})}
            onBlur={(value) => saveData({id,authority:authority || " "})}
          />
        </Grid.Column>
        <Grid.Column width="2" className="divFormFeild  border-bottom  b-rw-0">
          <InputField
            isLabel={false}
            id={`amount-${id}`}
            type="number"
            label={translate("AMOUNT", {ns:["default", "header"]})}
            value={part}
            className="field-bg"
            clearInput={false}
          //  disabled={isFormDisabled}
            onChange={(value) => updateData(id, {"part":value})}
            onBlur={(value) => saveData({id,part:part || " "})}
          />
        </Grid.Column>
        <Grid.Column width="2" className="divFormFeild  border-bottom">
          <InputField
            isLabel={false}
            id={`qty-${id}`}
            type="number"
            value={qty}
            label={translate("QUANTITY", {ns:["default", "header"]})}
            className={"field-bg"}
            clearInput={false}
           // disabled={isFormDisabled}
            onChange={(value) => updateData(id,{"qty":value})}
            onBlur={(value) => saveData({id,qty:qty || " "})}
          />
        </Grid.Column>
        <Grid.Column width="1" className="icon-delete-add-info">
          
            <span>
              
                <Icon
                  id={`supportingDocs-delete-${id}`}
                  name="trash alternate outline"
                  onClick={() => {
                    deleteData(id)
                  }}
                  disabled={isFormDisabled}
                />
              
            </span>
           
        </Grid.Column>
      </Grid.Row>
   
  );
}

export default React.memo(SupportingDocumentDetails)
